export enum DisputeStatus {
  Won = 'WON',
  Lost = 'LOST',
  Appealed = 'APPEALED',
  Initiated = 'INITIATED',
  ReasonUpdated = 'REASON_UPDATED',
}
